
import { Component, Prop, Vue } from "vue-property-decorator";
import t from "@common/src/i18n/t";

@Component({
  model: {
    prop: "checked",
    event: "click"
  }
})
export default class BtnCheck extends Vue {
  @Prop({ default: () => t("other.remember-discount") })
  btnText: string;
  @Prop({ default: false })
  checked: boolean;
  @Prop({ default: false })
  value: boolean;
  @Prop({ default: false })
  disabled: boolean;
  get $checked() {
    return this.checked;
  }
  handleStatusChange() {
    if (this.disabled) return;
    this.$emit("click", !this.checked);
    this.$emit("change", !this.checked);
  }
}
